module.exports = __webpack_public_path__ + "/images/coachmark-arrow.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/coachmark-arrow.svg
// module id = 616
// module chunks = 0